<template>
   <app-parser_wrapper  :init="init">    </app-parser_wrapper>
</template>

<script>
 export default {

     data () {
       return {
   init: {
     menu:{
       items: [
         {
           title:"Глобальный поиск",
           objName: 'videos_global_search',
           dataType:"videos",
           form: [
           {
             type:'select',
             name: 'Сортировка результатов',
             options: [{text:'По умолчанию',value:''},{text:'по дате добавления видеозаписи',value:'0'},{text:'по длительности',value:'1'},{text:'по релевантности',value:'2'} ],
             vModel: {name:'sort',value:''},
             vkapi: true
           },
           {
             type:'select',
             name: 'Фильтр',
             options: [{text:'По умолчанию',value:''},{text:' Только видео в формате mp4 ',value:'mp4'},{text:'только youtube видео',value:'youtube'},{text:'Только vimeo видео',value:'vimeo'},{text:'Только короткие видеозаписи',value:'short'},{text:'Только длинные видеозаписи',value:'long'} ],
             vModel: {name:'filters',value:''},
             vkapi: true
           },
           {
             type:'input',
             name: 'Длинне чем (число в секундах)',
             vModel: {name:'longer',value:''},
             vkapi: true
           },
           {
             type:'input',
             name: 'Короче чем (число в секундах)',
             vModel: {name:'shorter',value:''},
             vkapi: true
           },
           {
             type:'checkbox',
             name: 'Без ограничений',
             vModel: {name:'adult',value:0},
             vkapi: true
           },
           {
             type:'input',
             name: 'Колличество с фразы',
             vModel: {name:'count',value:''},
             vkapi: true
           },
           ],
         },

       ],
     },
    title:{
      first: 'Видео найденно: '
    },

    searchLoop:{
      active:true,
      placeholder:'Названия видео'
    },

    beforeSearch:{
      title: 'Тут будет отображен результат поиска видео',
      activator: false,
      activatorName: 'Начать парсинг'
    },


    network:{
      processName: 'videos_global_search',
      dataType: 'videos',
      actionsFile:  'http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/searcher/videos_global_search.php'
    },




    contentMenegment: {
      marginTop: '0px',
      items: {
        selector: {active:true},
        copy: {active:true},
        export: {active:true},
        update: {active:false},
        delete: {active:false},
        autoExport: {active:false}
      },
      contentInfo: {
        type: 'videos',
      },
      autoExport: {
        isActive: false,
        tasksList:[],
      }
     },
     progressСircular: true,
   }


       }
     }
   }
</script>


<style>

</style>
